import React from "react";
import { useDispatch, useSelector } from 'react-redux';
import { setformmodal } from '../../redux/formslice';
import { setotpmodal ,setprofilenotupdate} from '../../redux/formslice';
import Register from './Register';
import Modal from 'react-bootstrap/Modal';
import Login from './Login';
import { IoClose } from "react-icons/io5";
import OTPVerification from './OtpVerifiaction';
import leftarrow from "../../images/Arrow - Left 2.png";
import { useNavigate } from 'react-router-dom';
import ForgotPssword from "./ForgotPssword";

const Mobileforms = () => {
    const formmodal = useSelector((state) => state.formslice.formmodal)
    const optmodalopen = useSelector((state) => state.formslice.optmodalopen)
    const formstatus = useSelector((state) => state.formslice.formstatus);
    const profilenotupdate = useSelector((state) => state.formslice.profilenotupdate);
    const dispatch = useDispatch();
    const navigate = useNavigate();
        const otpmodalhandle =()=>{
            dispatch(setotpmodal(!optmodalopen))
            dispatch(setprofilenotupdate(!profilenotupdate))
    
        }
    
    const modalbackaction = () => {
        dispatch(setformmodal(!formmodal))
        // if(formstatus == 1){
        //     dispatch(setformmodal(!formmodal))
        // }
        // else{

        // }
        
    };
    return (
        <div>
            <div className={`formsidebar ${formmodal ? "open" : ""}`}>
                <div className="form-topcontent">
                    <div className='modalclose formmodal-topicons '>
                        <img src={leftarrow} onClick={modalbackaction}></img>    <IoClose size={20} onClick={() => { dispatch(setformmodal(!formmodal)) }} />
                    </div>
                    <div className="mobile-form-titles">
                        <div className="FormHeading">
                            {
                                formstatus == 1 && 'Login'
                            }
                            {
                                formstatus == 2 && 'Create an account'
                            }
                            {
                                formstatus == 4 && 'Forgot Password'
                            }

                        </div>
                        <div className="formsubheading">
                            {
                                formstatus == 1 && 'If you have an account with us, please login.'
                            }
                            {
                                formstatus == 2 && "Looks like you're new here!"
                            }
                            {
                                formstatus == 4 && "Please fill the form to get your password"
                            }




                        </div>
                    </div>
                </div>
                {
                    formstatus == 1 &&
                    <Login />
                }
                {
                    formstatus == 2 &&
                    <Register />
                }
                {
                    formstatus == 4 &&
                    <ForgotPssword />
                }
                <Modal
                    show={optmodalopen}
                    onHide={!optmodalopen}
                    backdrop="static"
                    keyboard={false}
                    centered
                >
                    <div className='modalclose d-flex justify-content-end pe-2 pt-2 '>
                        <IoClose size={20} onClick={otpmodalhandle} />
                    </div>
                    <OTPVerification />

                </Modal>
            </div>
        </div>
    )
}
export default Mobileforms;